export default "__VITE_ASSET__431e9895__"